module.exports = __webpack_public_path__ + "img/phone.4ab5e783.svg";